import React from "react";
import GitHubCalendar from "react-github-calendar";

function Github() {
  return (
    <section className="github-panel">
      <div className="section-header">
        <span className="section-eyebrow">GitHub</span>
        <h2 className="section-heading">Contribution History</h2>
      </div>
      <div className="github-calendar-shell" role="region" aria-label="GitHub contributions, scroll horizontally for the full year" tabIndex={0}>
        <GitHubCalendar
          username="dixonfrederick"
          blockSize={14}
          blockMargin={6}
          color="#faff69"
          fontSize={14}
        />
      </div>
      <a className="section-link github-profile-link" href="https://github.com/dixonfrederick" target="_blank" rel="noreferrer">
        View GitHub Profile
      </a>
    </section>
  );
}

export default Github;
